import React, { useEffect, useState } from 'react';
import './WeeklyMatchCountdown.css';

const getParts = (ms) => {
  const totalMinutes = Math.max(0, Math.floor(ms / 60000));
  return {
    days: Math.floor(totalMinutes / (60 * 24)),
    hours: Math.floor((totalMinutes % (60 * 24)) / 60),
    minutes: totalMinutes % 60,
  };
};

// Countdown to a fixed one-time date (the 30-day auto-delete deadline) —
// reuses WeeklyMatchCountdown's box styling for visual consistency, but
// with its own simpler "count down to a fixed Date" logic rather than
// WeeklyMatchCountdown's "next weekly occurrence" logic.
const DeletionCountdown = ({ targetDate, light = true }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000 * 30);
    return () => clearInterval(interval);
  }, []);

  const remainingMs = new Date(targetDate).getTime() - now.getTime();
  const { days, hours, minutes } = getParts(remainingMs);

  return (
    <div className={`weekly-match-countdown${light ? ' weekly-match-countdown--light' : ''}`}>
      <div className="weekly-match-countdown-clock">
        <div className="weekly-match-countdown-cell">
          <span className="weekly-match-countdown-number">{days}</span>
          <span className="weekly-match-countdown-unit">days</span>
        </div>
        <div className="weekly-match-countdown-cell">
          <span className="weekly-match-countdown-number">{hours}</span>
          <span className="weekly-match-countdown-unit">hrs</span>
        </div>
        <div className="weekly-match-countdown-cell">
          <span className="weekly-match-countdown-number">{minutes}</span>
          <span className="weekly-match-countdown-unit">min</span>
        </div>
      </div>
      <div className="weekly-match-countdown-label">
        until automatic deletion
      </div>
    </div>
  );
};

export default DeletionCountdown;
